module.exports = __webpack_public_path__ + "static/media/head-side-brain.4578cb34.svg";